import React from "react";
// import __ from 'lodash';

class DropdownProfilCbtDinas extends React.Component {
  render() {
    return this.props.jadwalProfilCbt.map((val) => (
      <option key={val.ID_JADWAL_PROFIL_CBT} value={val.ID_JADWAL_PROFIL_CBT}>
        {val.NAMA_JADWAL_CBT} ({val.KODE_TAHUN_AJARAN})
      </option>
    ));
  }
}

export default DropdownProfilCbtDinas;
